import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { NvMatTooltipModule } from '../../../../shared/components/nv-mat-tooltip/nv-mat-tooltip.module';
import { ListDisplayModule } from '../list-display.module';
import { ListDisplayStudentActivities } from './list-display-student-activities.component';

@NgModule({
  declarations: [ListDisplayStudentActivities],
  imports: [CommonModule, ListDisplayModule, NvMatTooltipModule, MatMenuModule, MatIconModule],
  exports: [ListDisplayStudentActivities],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class ListDisplayStudentActivitiesModule {
  /** */
}
